import { TranslationsFunc } from '@lang';

type CheckInOutSettings = {
  checkInTime?: string | null;
  checkOutTime?: string | null;
};

export const formatCheckInOutLine = (t: TranslationsFunc, roomSettings?: CheckInOutSettings) =>
  [
    roomSettings?.checkInTime &&
      t('checkout.termsAndConditions.checkIn', { time: roomSettings.checkInTime }),
    roomSettings?.checkOutTime &&
      t('checkout.termsAndConditions.checkOut', { time: roomSettings.checkOutTime }),
  ]
    .filter(Boolean)
    .join(' / ');
